import { addParamsWithConditions } from '@xing-com/xing-tracking';

type TrackingUrlHOFProps = {
  to?: string;
  trackingKey?: string;
  conditions?: Record<string, (value: [string, string]) => string>;
};

const getTrackingUrlHOF =
  (trackings: Record<string, Record<string, string | [string, string]>>) =>
  ({ to = '', trackingKey, conditions = {} }: TrackingUrlHOFProps): string => {
    return addParamsWithConditions(
      to,
      (trackingKey && trackings[trackingKey]) || {},
      conditions
    );
  };

const nav = {
  viewPagePromote: { sc_o: 'entity_page_promote' },
  viewXBM: { sc_o: 'entity_page_analyse' },
};

const contacts = {
  viewAllContacts: { sc_o: 'entity_page_view_all_contacts' },
  viewContactProfileMain: {
    sc_o: 'entity_page_profile_other_visit_main_contact',
  },
  viewContactProfileSubpage: {
    sc_o: 'entity_page_profile_other_visit_sub_contact',
  },
  backToOverviewFromContactSubpage: { sc_o: 'entity_page_back_to_overview' },
};

const employees = {
  viewAllEmployees: { sc_o: 'entity_page_view_all_employees' },
  viewEmployeesProfileMain: {
    sc_o: 'entity_page_profile_other_visit_main_employees',
  },
  viewEmployeesProfileSubpage: {
    sc_o: 'entity_page_profile_other_visit_sub_employees',
  },
  backToOverviewFromEmployeesSubpage: { sc_o: 'entity_page_back_to_overview' },
};

const jobs = {
  viewJobProfile: { ijt: 'jb_40' },
  viewAllJobs: {
    sc_o: 'entity_page_view_all_jobs',
  },
  viewJobOffers: {
    sc_o: 'entity_page_job_offers_sub_page ',
  },
};

const companyRecommendations = {
  viewCompanyRecommendation: {
    sc_o: 'entity_page_main_recommended_module_visit',
  },
};

const aboutUs = {
  visitAffiliate: {
    sc_o: 'entity_page_about_us_affiliate_visit',
  },
  discoverMore: {
    sc_o: 'entity_page_about_us_discover_more_button',
  },
  learnMoreLink: {
    sc_o: 'entity_page_about_us_learn_more_link',
  },
  allAwards: {
    sc_o: 'entity_page_about_us_all_awards_link',
  },
};

export const getTrackingUrl = getTrackingUrlHOF({
  ...nav,
  ...contacts,
  ...employees,
  ...jobs,
  ...companyRecommendations,
  ...aboutUs,
});
